<template>
	<v-container class="w-100 d-flex flex-column text-body-2 font-weight-light" style="height: 500px" :class="smAndDown ? 'py-0 pb-16' : 'pt-16 '">
		<div class="d-flex w-100 mt-auto">
			<v-spacer />
			<v-row class="w-50" :class="smAndDown ? '' : 'text-end'">
				<v-spacer />
                <v-col :cols="smAndDown ? 4 : 3" class="d-flex flex-column text-end">
					<div class="roboto-flex-light pb-4">Tools</div>
                    <div class="d-flex flex-column links">
					    <a v-for="tool in tools" :href="tool.href" target="_blank" rel="noreferrer noopener" class="mb-4">{{ tool.title }}</a>
                    </div>
				</v-col>
				<v-col :cols="smAndDown ? 4 : 3" class="d-flex flex-column text-end">
					<div class="roboto-flex-light pb-4">About</div>
                    <div class="d-flex flex-column links">
					    <router-link class="mb-4" to="/" :class="$route.path !== '/' ? '' : 'text-blue-darken-4'">Home</router-link>
                        <a href="https://blog.june07.com" target="_blank" rel="noreferrer noopener" class="mb-4">Blog</a>
                    </div>
				</v-col>
				<v-col :cols="smAndDown ? 4 : 3" class="d-flex flex-column">
					<div class="roboto-flex-light pb-4">Legal</div>
                    <div class="d-flex flex-column links">
                        <a class="mb-4" href="https://june07.com/terms">Terms</a>
                        <a href="https://june07.com/privacy">Privacy</a>
                    </div>
				</v-col>
			</v-row>
		</div>
		<v-divider class="my-4" thickness="2" />
		<div class="d-flex text-grey" :class="smAndDown ? 'text-caption text-no-wrap flex-column' : ''">
			© 2025 June07
			<v-spacer />
			<div class="font-italic font-weight-light">Happy Graduation to You!</div>
		</div>
	</v-container>
</template>
<style scoped>
a {
	text-decoration: none;
	color: inherit;
}
.links {
    font-size: 0.5rem;
}
</style>
<script setup>
import { ref } from 'vue'
import { useDisplay } from 'vuetify/lib/framework.mjs'

const { smAndDown } = useDisplay()
const tools = ref([
    {
        title: 'Jenkinsfile',
        href: 'https://packagecontrol.io/packages/Jenkinsfile'
    }, {
        title: 'NiM',
        href: 'https://nim.june07.com'
    }
])
</script>
